<div *ngIf="isAnnonymous">
  <img  class="thumbs"
    *ngIf="image?.mime_type === 'image'"
    #img
    [id]="image?.id"
    [alt]="image?.mime_type"
    [src]="image?.thumbUrl"
    (load)="calculateRows()"
  />
  <img class="thumbs"
    *ngIf="image?.mime_type === 'video'"
    #img
    [id]="image?.id"
    [alt]="image?.mime_type"
    [src]="image?.thumbUrl"
    (load)="calculateRows()"
  />
  <img class="thumbs"
    *ngIf="imageIndex == 51 || imageIndex-1 == totalImages"
    #img
    [id]="image?.id"
    [alt]="image?.mime_type"
    src="/assets/images/picaggoLogin.png"
    style="opacity: 0.3"
    (load)="calculateRows()"
  />
  <div class="video-icon-overlay" *ngIf="image?.mime_type === 'video'">
    <i class="fa fa-play"></i>
  </div>
  
</div>

<div *ngIf="!isAnnonymous" class="imgContainer">
  
  <i class="fa fa-user-o" *ngIf="isDeleteEnabled && (userId !== image?.user_id)" aria-hidden="true"></i>
  <mat-checkbox  *ngIf="isDeleteEnabled" (change)="toggleSelection(image)" (click)="$event.stopPropagation()" [checked]="image?.selected" class="custom-checkbox" style="pointer-events: all !important;"></mat-checkbox>
  
  <img class="thumbs"
    *ngIf="image?.mime_type === 'image'"
    #img
    [id]="image?.id"
    [alt]="image?.mime_type"
    [src]="image?.thumbUrl"
    (load)="calculateRows()" [style.transform]="rotationAngle"
  />
  <img class="thumbs item-video" 
    *ngIf="image?.mime_type === 'video'"
    #img
    [id]="image?.id"
    [alt]="image?.mime_type"
    [src]="image?.thumbUrl"
    (load)="calculateRows()" [style.transform]="rotationAngle"
  />
  <div class="video-icon-overlay" *ngIf="image?.mime_type === 'video'">
    <i class="fa fa-play"></i>
  </div>
  
</div>

<!-- <div style="text-align: center; font-weight: 600;">{{ imageIndex}}/{{totalImages}}</div> -->
